import * as Styles from './styles';

type LedgerPaginationProps = {
    currentPage: number;
    totalPages: number;
    rowsPerPage?: number;
    onPageChange: (page: number) => void;
};

function LedgerPagination({
    currentPage,
    totalPages,
    rowsPerPage,
    onPageChange,
}: LedgerPaginationProps) {
    const visiblePages = () => {
        if (totalPages <= 5) {
            return Array.from({ length: totalPages }, (_, index) => index + 1);
        }
        if (currentPage <= 3) {
            return [1, 2, 3, 4, '...', totalPages];
        }
        if (currentPage >= totalPages - 2) {
            return [
                1,
                '...',
                totalPages - 3,
                totalPages - 2,
                totalPages - 1,
                totalPages,
            ];
        }
        return [
            1,
            '...',
            currentPage - 1,
            currentPage,
            currentPage + 1,
            '...',
            totalPages,
        ];
    };

    return (
        <Styles.PaginationRow>
            {rowsPerPage != null && (
                <Styles.PaginationMeta>
                    {`Rows per page: ${rowsPerPage}`}
                </Styles.PaginationMeta>
            )}
            <Styles.PaginationArrow
                disabled={currentPage === 1}
                onClick={() => onPageChange(Math.max(1, currentPage - 1))}
            >
                {'<'}
            </Styles.PaginationArrow>
            {visiblePages().map((page, index) =>
                page === '...' ? (
                    <Styles.PaginationDots key={`dots-${index}`}>
                        ...
                    </Styles.PaginationDots>
                ) : (
                    <Styles.PageButton
                        key={`page-${page}`}
                        isActive={currentPage === Number(page)}
                        onClick={() => onPageChange(Number(page))}
                    >
                        {page}
                    </Styles.PageButton>
                )
            )}
            <Styles.PaginationArrow
                disabled={currentPage === totalPages}
                onClick={() =>
                    onPageChange(Math.min(totalPages, currentPage + 1))
                }
            >
                {'>'}
            </Styles.PaginationArrow>
        </Styles.PaginationRow>
    );
}

export default LedgerPagination;
